module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "scene-root"
  }, [_c('PerspectiveCamera', {
    attrs: {
      "fov": 75,
      "aspect": _vm.aspect,
      "near": 1,
      "far": 1000
    },
    on: {
      "camera": function (v) {
        _vm.camera = v;
      }
    }
  }), _vm._v(" "), _c('Scene', {
    on: {
      "scene": function (v) {
        _vm.scene = v;
      }
    }
  }, [_c('Mesh', {
    ref: "mesh-1"
  }, [_c('MeshPhongMaterial', {
    attrs: {
      "opacity": 0
    }
  }), _vm._v(" "), _c('SphereGeometry')], 1), _vm._v(" "), _c('PointLight')], 1), _vm._v(" "), (_vm.camera && _vm.scene) ? _c('Raycaster', {
    attrs: {
      "camera": _vm.camera,
      "scene": _vm.scene
    },
    on: {
      "setMouse": function (v) {
        _vm.$emit('setMouse', v);
        _vm.setMouse = v;
      },
      "hover": function (v) {
        _vm.hover = v
      },
      "glClick": _vm.handleHit
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298e191a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prototypes/Scene/Red.vue
// module id = 582
// module chunks = 0